import { combineReducers } from "redux";
import loading from "./loading";
import login from "./login";
import user from "./user";

export default combineReducers({
  loading,
  login,
  user,
});